import { EventTrackingProvider } from "@newsela/snitch";
import PropTypes from "prop-types";

import useEventStreamConsent from "@/eventStream/useEventStreamConsent/useEventStreamConsent";
import useUser from "@/users/useUser";
import useGetPreviousUrl from "../useGetPreviousUrl";
import { useSnitchPlatform } from "./useSnitchPlatform";
import type { ReactNode } from "react";

const propTypes = {
  children: PropTypes.node,
};

const EventTrackingProviderSnitch = ({ children }: { children: ReactNode }) => {
  const { data: user } = useUser();
  const getPreviousUrl = useGetPreviousUrl();
  const isConsentGranted = useEventStreamConsent();
  const snitchPlatform = useSnitchPlatform();
  return (
    <EventTrackingProvider
      userInfo={{ userId: user?.id, uniqueUserId: user?.unique_id }}
      getPreviousUrl={getPreviousUrl}
      {...snitchPlatform}
      isConsentGranted={isConsentGranted}
    >
      {children}
    </EventTrackingProvider>
  );
};

EventTrackingProviderSnitch.propTypes = propTypes;

export default EventTrackingProviderSnitch;
